let config = {
  url: "https://teachdigital.nl",
  consumerKey: "ck_54b363ba0f47c9762f851d7f71515299ff36c6c9",
  consumerSecret: "cs_c9f275f3b6ae9292cc8ccf2a5abcbec51a1caa25",
  version: "wc/v3"
}

module.exports = {
	config
}